import Cart from './components/cart';
import Christmas from './components/christmas';
import CopyToClipboard from './components/copyToClipboard';
import CountDown from './components/countDown';
import cyclicPackages from './components/cyclic-packages';
import ExitPopup from './components/exit-popup';
import GenerateProductsInBlog from './components/generateProductsInBlog';
import LandingPages from './components/landingPages';
import Payu from './components/payu';
import Phone from './components/phone';
import Singleproduct from './components/singleproduct';
import Sliders from './components/sliders';
import Subscriptions from './components/subscriptions';
import videoPlayer from './components/videoPlayer';
import YoutubeIframes from './components/youtubeIframes';
import DataLayer from './components/datalayer';
import NoCache from './components/no-cache';
import Counters from './components/counters';
import Reviews from './components/reviews';
import Blog from './components/blog';
import PackagesBs from './components/packages-bs';

document.addEventListener('DOMContentLoaded', function() {

    Subscriptions();
    cyclicPackages();
    CountDown();
    Phone();
    YoutubeIframes();
    Sliders();
    Payu();
    LandingPages();
    Cart();
    Christmas();
    Singleproduct();
    videoPlayer();
    ExitPopup();
    GenerateProductsInBlog();
    CopyToClipboard();
    ExitPopup();
    DataLayer();
    Counters();
    Reviews();
    Blog();
    PackagesBs();


    // Przekierowanie linku na konkretną podstronę po kliknięciu
    var topBarRedirect = document.getElementsByClassName("top-bar-custom-countdown");

    if(topBarRedirect) {
        for (var i = 0; i < topBarRedirect.length; i++) {
            topBarRedirect[i].addEventListener("click", function() {
                window.location.href = "/produkty/";
            });
        }
    }

    // Teleopieka - bs.03 + bs.04 

    const teleBtn = Array.from(document.getElementsByClassName('packages__telecare-item'));
    const teleHiddenWrapper = Array.from(document.querySelectorAll('div[data-id="pa_dodatkowy-pakiet"] div'));
    const teleInfoBox = document.getElementsByClassName('telecare-info-box')[0];

    teleBtn.forEach(btn => {
        btn.addEventListener('click', function() {
            const activePackageNow = document.querySelector('.packages__items-item.active');
            const isTypeNone = this.dataset.type == 'none';
            const isTypeTele = this.dataset.type == 'tele';

            teleInfoBox?.classList.toggle('active', isTypeTele);

            teleHiddenWrapper
                .filter(wrapper => wrapper.dataset.value === (isTypeNone ? 'brak' : 'teleopieka-medyczna'))
                .forEach(wrapper => wrapper.click());

            teleBtn.forEach(btn => btn.classList.remove('active'));
            this.classList.add('active');

            updateTelePrices(isTypeNone ? 'none' : 'tele');

            setNewPayuRaty();
        });
    });

    function updateTelePrices(typeOfPrices) {
        const getAllPackagesPrices = Array.from(document.getElementsByClassName('packages__items-item'));
        const activeTeleItemPrices = document.querySelector('.packages__telecare-item.active');

        if (activeTeleItemPrices) {
            getAllPackagesPrices.forEach(pkg => {
                const getPriceWrappers = pkg.getElementsByClassName('packages__items-item-price')[0];

                console.log(getPriceWrappers);

                if (typeOfPrices == 'tele') {
                    getPriceWrappers.innerHTML = pkg.dataset.telePrice;
                } else if (typeOfPrices == 'none') {
                    getPriceWrappers.innerHTML = pkg.dataset.normalPrice;
                }
            });
        }
    }

    const allPackagesBtns = Array.from(document.getElementsByClassName('packages__items-item'));
    const allHiddenPackages = Array.from(document.querySelectorAll('div[data-id="pa_wybierz-pakiet"] div'));

    allPackagesBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            const activeTeleItem = document.querySelector('.packages__telecare-item.active');

            allPackagesBtns.forEach(btn => btn.classList.remove('active'));
            this.classList.add('active');

            allHiddenPackages
                .filter(hiddenPackage => hiddenPackage.dataset.value == this.dataset.value)
                .forEach(hiddenPackage => hiddenPackage.click());

            setNewPayuRaty();
        });
    });

    function changePackageIfZero() {
        if (window.location.href.includes('attribute_pa_wybierz-pakiet=zero')) {
            console.log('Parameterised URL');
            window.addEventListener('load', function() {
                setTimeout(() => {
                    allHiddenPackages
                        .filter(hiddenPackage => hiddenPackage.dataset.value == 'miesiecznie')
                        .forEach(hiddenPackage => {
                        hiddenPackage.click();
                        setNewPayuRaty();
                    });
                }, 500);
            })
        }
    }

    changePackageIfZero();

    function setNewPayuRaty() {

        const singleProductPrice = document.querySelector('.single-product .single_variation_wrap .price ins .woocommerce-Price-amount bdi');

        if(singleProductPrice) {
            let price = singleProductPrice.innerText.replace(/ /g,'').replace(',','.').replace('zł','').trim();
            let value = Number(price);
            
            if (value >= 200 && value <= 50000) {
                var options = {
                creditAmount: value,    // wartość jako number (w PLN)
                posId: '4169567',         // identyfikator punktu płatności
                key: '2b',              // pierwsze dwa znaki klucza api
                // showLongDescription: true
                };
                OpenPayU.Installments.miniInstallment('#installment-mini', options)
                    .then(function(result) {
                        // Ten fragment kodu zostanie wykonany po pokazaniu widżetu 
                        // obiekt 'result' przekazany w parametrze funkcji udostępnia dodatkowe opcje; 
                        // przykładowe użycie w FAQ pkt. 6 
                    })
                    .catch(function(e)  {
                        console.error(e.toString()); // Wypisanie błędów konfiguracji na konsolę 
                    });
            }
        }

    }

    // Toggle FAQ items

    const faqItems = document.querySelectorAll('#faq-new h3, #faq-new h4');

    if(faqItems) {
        for(var i = 0; i < faqItems.length; i++) {

            faqItems[i].addEventListener('click', function() {

                if(this.classList.contains('active')) {
                    this.classList.remove('active');
                } else (
                    this.classList.add('active')
                )

            })

        }
    }


    // MO switcher

    const moSelectPlus = document.getElementsByClassName('mo-select-plus')[0];
    const moSelectMinus = document.getElementsByClassName('mo-select-minus')[0];
    const moTitleSelect = document.getElementsByClassName('mo-select-title')[0];
    const moOptionPlus = document.getElementsByClassName('mo-option-plus')[0];
    const moOptionMinus = document.getElementsByClassName('mo-option-minus')[0];
    const titleId       = document.getElementById('select-product');
    const mpCustomBtn = document.getElementsByClassName('mo-select-plus-custom-btn');

    if(mpCustomBtn) {
        for(var i = 0; i < mpCustomBtn.length; i++) {
            mpCustomBtn[i].addEventListener('click', function() {

                moSelectPlus.click();

            })
        }
    }

    if(moSelectPlus) {
        moSelectPlus.addEventListener('click', function() {
            this.classList.add('active');
            moSelectMinus.classList.remove('active');
            if(moTitleSelect) {
                moTitleSelect.classList.add('active');
            }
            if(moOptionMinus) {
                moOptionMinus.classList.add('active');
            }
            if(moOptionPlus) {
                moOptionPlus.classList.remove('active');
            }
            // Znajdujemy sekcję z id "select-product" i obliczamy jej pozycję na stronie
            const selectProductSection = document.querySelector("#select-product");
            const selectProductSectionPosition = selectProductSection.offsetTop;

            // Używamy metody scrollTo, aby przewinąć stronę do pozycji sekcji "select-product"
            window.scrollTo({
                top: selectProductSectionPosition + 50,
                behavior: "smooth"
            });
        })
    }
    if(moSelectMinus) {
        moSelectMinus.addEventListener('click', function() {
            this.classList.add('active');
            moSelectPlus.classList.remove('active');
            if(moTitleSelect) {
                moTitleSelect.classList.add('active');
            }
            if(moOptionMinus) {
                moOptionMinus.classList.remove('active');
            }
            if(moOptionPlus) {
                moOptionPlus.classList.add('active');
            }
            // Znajdujemy sekcję z id "select-product" i obliczamy jej pozycję na stronie
            const selectProductSection = document.querySelector("#select-product");
            const selectProductSectionPosition = selectProductSection.offsetTop;

            // Używamy metody scrollTo, aby przewinąć stronę do pozycji sekcji "select-product"
            window.scrollTo({
                top: selectProductSectionPosition + 50,
                behavior: "smooth"
            });
        })
    }

    // Pobierz bieżący URL strony
    var currentUrl = window.location.href;

    // Sprawdź, czy parametr utm_content jest obecny w URL
    if (currentUrl.indexOf('utm_content') !== -1) {

        var utmContentValue = getParameterByName('utm_content', currentUrl);
        if (utmContentValue === 'btn60') {
            moSelectMinus.click();
        } else if(utmContentValue === 'btn90') {
            moSelectPlus.click();
        }
    }


    // Funkcja pomocnicza do pobierania wartości parametru z URL
    function getParameterByName(name, url) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        var results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    // Toggle more info in new lp

    const readMoreTarget = document.getElementsByClassName('read-more-target')[0];
    const readMoreBtn    = document.getElementsByClassName('read-more-btn')[0];

    if(readMoreBtn) {
        readMoreBtn.addEventListener('click', function() {

            if(readMoreTarget.classList.contains('active')) {
                this.innerText = 'Czytaj więcej';
                readMoreTarget.classList.remove('active');
            } else {
                this.innerText = 'Czytaj mniej';
                readMoreTarget.classList.add('active');
            }

        })
    }

    // Compare - show more

    const compareDesktopBtn = document.getElementsByClassName('compare-desktop--hidden-show-more')[0];
    const compareDekstopList = document.getElementsByClassName('compare-desktop-row--list')[0];
    const comapreBS04Wrapper = document.getElementsByClassName('compare-mobile--hidden-show-more-wrapper-bs04')[0];
    const comapreBS03Wrapper = document.getElementsByClassName('compare-mobile--hidden-show-more-wrapper-bs03')[0];
    const comapreBS04Click   = document.getElementsByClassName('compare-mobile--hidden-show-more-bs04')[0];
    const comapreBS03Click   = document.getElementsByClassName('compare-mobile--hidden-show-more-bs03')[0];

    if(comapreBS04Click) {
        comapreBS04Click.addEventListener('click', function() {
            if(comapreBS04Wrapper) {
                comapreBS04Wrapper.classList.add('active');
                comapreBS04Click.classList.add('hidden');
            }
        })
    }
    if(comapreBS03Click) {
        comapreBS03Click.addEventListener('click', function() {
            if(comapreBS03Wrapper) {
                comapreBS03Wrapper.classList.add('active');
                comapreBS03Click.classList.add('hidden');
            }
        })
    }
    if(compareDesktopBtn) {
        compareDesktopBtn.addEventListener('click', function() {
            if(compareDekstopList) {
                compareDekstopList.classList.add('active');
                compareDesktopBtn.classList.add('hidden');
            }
        })
    }

    const noProductsInStock = document.querySelector('.single-product .summary-inner .no-products-box');
    const noProductsProductWrapper = document.querySelector('.single-product-page .summary-inner');
    if(noProductsInStock) {
        noProductsProductWrapper.classList.add('no-products-in-stock');
    }

    // Custom search form on blog page
    const searchForm = document.getElementsByClassName('custom-search-form')[0];

    if(searchForm) {
        searchForm.addEventListener('submit', function(event) {
            event.preventDefault();  // Zatrzymujemy domyślne działanie formularza
            
            var searchQuery = document.querySelector('.custom-search-form__input input').value;
            var searchUrl = `https://bezpiecznarodzina.pl/?s=${encodeURIComponent(searchQuery)}&post_type=post`;
    
            window.location.href = searchUrl;  // Przekierowujemy do strony wyników wyszukiwania
        });
    }

    const allCoflowElements = document.getElementsByClassName('security__functions-items-item');

    if(allCoflowElements) {
        for(var i = 0; i < allCoflowElements.length; i++) {
            allCoflowElements[i].addEventListener('click', function() {

                if(this.classList.contains('active')) {
                    this.classList.remove('active');
                } else {
                    this.classList.add('active');
                }

            })
        }
    }

    // Scroll to 

    const bsMenuItems = document.querySelectorAll('.security__menu-item');

    if(bsMenuItems) {
        bsMenuItems.forEach(item => {
            item.addEventListener('click', function (e) {
                e.preventDefault();
        
                const id = this.getAttribute('href').substring(1);
                const element = document.getElementById(id);
                const y = element.getBoundingClientRect().top + window.pageYOffset - 150;
        
                window.scrollTo({top: y, behavior: 'smooth'});
            });
        });
    }

    // Play iframe video on click dummy

    const dummyBtn = document.getElementsByClassName('security__movie-dummy');

    if(dummyBtn) {
        for(var i = 0; i < dummyBtn.length; i++) {
            dummyBtn[i].addEventListener('click', function() {

                this.classList.add('hidden');

                let iframe = this.parentNode.getElementsByTagName('iframe')[0]

                iframe.src = iframe.dataset.src;

            })
        }
    }


    // Nadcisnienie JS:

    const securityForm = document.getElementsByClassName('security__form')[0];
    const quantityPlus = document.getElementsByClassName('security__products-packages-final-quantity-plus')[0];
    const quantityMinus = document.getElementsByClassName('security__products-packages-final-quantity-minus')[0];
    const quantityInput = document.querySelector('.security__products-packages-final-quantity-input input');

    if(securityForm) {
        securityForm.addEventListener('submit', function(el) {
            el.preventDefault();

            let packageType = document.querySelector('input[name="package-type"]:checked');
            let productType = document.querySelector('input[name="product-type"]:checked');

            let productTypeData = productType.dataset.productType;
            let packageTypeData = packageType.dataset.packageType;

            console.log(productTypeData,packageTypeData);

            let linkRedirect = '';

            if(productTypeData == 'bs.03' && packageTypeData == '1m') {
                linkRedirect = 'https://bezpiecznarodzina.pl/?add-to-cart=16511&quantity=' + quantityInput.value;
            } else if(productTypeData == 'bs.03' && packageTypeData == '6m') {
                linkRedirect = 'https://bezpiecznarodzina.pl/?add-to-cart=16513&quantity=' + quantityInput.value;
            } else if(productTypeData == 'bs.03' && packageTypeData == '12m') {
                linkRedirect = 'https://bezpiecznarodzina.pl/?add-to-cart=16514&quantity=' + quantityInput.value;
            } else if(productTypeData == 'bs.03' && packageTypeData == '1mtel') {
                linkRedirect = 'https://bezpiecznarodzina.pl/?add-to-cart=16515&quantity=' + quantityInput.value;
            } else if(productTypeData == 'bs.03' && packageTypeData == '6mtel') {
                linkRedirect = 'https://bezpiecznarodzina.pl/?add-to-cart=16516&quantity=' + quantityInput.value;
            } else if(productTypeData == 'bs.03' && packageTypeData == '12mtel') {
                linkRedirect = 'https://bezpiecznarodzina.pl/?add-to-cart=16517&quantity=' + quantityInput.value;
            } else if(productTypeData == 'bs.04' && packageTypeData == '1m') {
                linkRedirect = 'https://bezpiecznarodzina.pl/?add-to-cart=15666&quantity=' + quantityInput.value;
            } else if(productTypeData == 'bs.04' && packageTypeData == '6m') {
                linkRedirect = 'https://bezpiecznarodzina.pl/?add-to-cart=15667&quantity=' + quantityInput.value;
            } else if(productTypeData == 'bs.04' && packageTypeData == '12m') {
                linkRedirect = 'https://bezpiecznarodzina.pl/?add-to-cart=15668&quantity=' + quantityInput.value;
            } else if(productTypeData == 'bs.04' && packageTypeData == '1mtel') {
                linkRedirect = 'https://bezpiecznarodzina.pl/?add-to-cart=16479&quantity=' + quantityInput.value;
            } else if(productTypeData == 'bs.04' && packageTypeData == '6mtel') {
                linkRedirect = 'https://bezpiecznarodzina.pl/?add-to-cart=15669&quantity=' + quantityInput.value;
            } else if(productTypeData == 'bs.04' && packageTypeData == '12mtel') {
                linkRedirect = 'https://bezpiecznarodzina.pl/?add-to-cart=15670&quantity=' + quantityInput.value;
            }

            console.log(linkRedirect);

            window.location.href = linkRedirect;

        })
    }
    if(quantityMinus) {
        quantityMinus.addEventListener('click', function() {
            if(Number(quantityInput.value) > 1) {
                quantityInput.value = Number(quantityInput.value) - 1;
            }
        })
    }
    if(quantityPlus) {
        quantityPlus.addEventListener('click', function() {
            if(Number(quantityInput.value < 100)) {
                quantityInput.value = Number(quantityInput.value) + 1;
            }
        })
    }

})

window.addEventListener('load', function() {

	setTimeout(() => {
    	const moviesItems = document.querySelectorAll('.vc_video-bg iframe');

			if(moviesItems) {
				for(var i = 0; i < moviesItems.length; i++) {
					moviesItems[i].setAttribute('muted','');
					moviesItems[i].setAttribute('playsinline','');
				}
			}
	}, 500);
	
})